// extracted by mini-css-extract-plugin
export default {"modal":"DobModal_modal__d28ae","close":"DobModal_close__XwLL3","header":"DobModal_header__Oqv4+","button":"DobModal_button__vwr6w"};